import {useEffect, useState} from "react";

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState<boolean>();
    useEffect(() => {
        const sUserAgent = navigator.userAgent
        const mobileAgents = ['Android', 'iPhone', 'Symbian', 'WindowsPhone', 'iPod', 'BlackBerry', 'Windows CE']
        for (let i = 0; i < mobileAgents.length; i++) {
            if (sUserAgent.includes(mobileAgents[i])) {
                setIsMobile(true)
                return;
            }
        }
        setIsMobile(false)
    }, [])
    return isMobile
}
